import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/services/message.service';
import { SocketService } from 'src/app/services/socket.service';
import { ToastrService, IndividualConfig } from 'ngx-toastr';
import { Message } from 'src/app/app.models';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.scss']
})
export class ChatBoxComponent implements OnInit, OnDestroy {

  //INPUT
  @Input('key') key: string;

  //Subscription
  listOfChatSubscription: Subscription;
  createMessageSubsciption: Subscription;
  fetchMessageSubscription: Subscription;

  //boolean
  fetch: boolean = false;
  created: boolean = false;

  listChat: Array<any>;

  messages: Array<any> = [];

  user: any;

  idRenting: number;
  receiver: number;

  public form!: UntypedFormGroup;

  constructor(private socketService: SocketService,
              private messageService: MessageService,
              private toastr: ToastrService,
              public formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {

    this.webSocket();

    this.initProperty();
    
  }

  private initProperty() {
   
    this.form = this.formBuilder.group({
      message: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],  
    });

    this.user = JSON.parse(localStorage.getItem("user")!)

    this.listOfChatSubscription = this.messageService.listOfChat(this.user.id, this.key).subscribe((list: any) => {
      
      // console.log(list, this.key);

      this.listChat = list['messages'];

      if(this.listChat.length > 0) {

        this.idRenting = this.listChat[0]['id'];

        if(this.key == 'lodger') {

          this.receiver = this.listChat[0]['prop_id'];

        } else {

          this.receiver = this.listChat[0]['loc_id'];
        }

        this.fetchMessage();

      }

    })
  }

  private webSocket() {

    let pusher = this.socketService.initSocket();

    var channel = pusher.subscribe('channel-message');
    channel.bind('new-message-request', (response : any) => {
      
      if(response.message.renting_id == this.idRenting && response.message.receiver_id == this.user.id) {

        this.messages.push(response.message);

      }

    });
    
  }

  public sendMessage() {

    if(this.form.status == 'INVALID') {

      this.toastr.show("Veuillez saisir votre message","Erreur Erreur",
        {
          timeOut: 5000,
          closeButton: true,
        } as IndividualConfig,
        "toast-" + "error"
      );

    } else {

      let obj : Message;

      if(this.idRenting == undefined) {

        this.toastr.show("Aucune reservation n'a été sélectionné","Erreur Erreur",
        {
          timeOut: 5000,
          closeButton: true,
        } as IndividualConfig,
        "toast-" + "error"
        );

      } else {

        obj = {
          'message_text': this.form.value.message.trim(),
          'renting_id' : this.idRenting,
          'transmitter_id': this.user.id,
          'receiver_id': this.receiver,
          'key': this.key,
          'created_at': new Date()
        }

        this.messages.push(obj);

        //Nous reintialisons le formumlaire
        this.form.reset();
        
        // console.log(obj);
         
        this.createMessageSubsciption = this.messageService.sendMessage(obj).subscribe(response => {
   
           // console.log(response, this.messageLogder);
   
        })

      }

    }
    
  }

  public currentRenting(idRenting: number, idReceiver: number) {

    this.idRenting = idRenting;
    this.receiver = idReceiver;

    this.fetchMessage();

  }

  /**
   * Cette methode permet de récuperer tous les messages concernant une reservation
   * @param key 
   */
  public fetchMessage() {

    this.fetchMessageSubscription = this.messageService.fetchMessage(this.idRenting).subscribe((message: any) => {
          
      this.messages = message.messages;

      this.fetch = true;

      // console.log(this.messages);

    })

  }


  ngOnDestroy(): void {
    
    this.listOfChatSubscription.unsubscribe();

    if(this.fetch) {

      this.fetchMessageSubscription.unsubscribe();

    }

    if(this.created) {

      this.createMessageSubsciption.unsubscribe();

    }

  }

}
